
import cardVisa from '../../../../assets/images/payment-icon-set/icons/visa-curved-32px.png';
import cardMasterCard from '../../../../assets/images/payment-icon-set/icons/mastercard-curved-32px.png';
import cardAmericanExpress from '../../../../assets/images/payment-icon-set/icons/american-express-curved-32px.png';
import cardVisaElectron from '../../../../assets/images/payment-icon-set/icons/visa-electron-curved-32px.png';
import cardMaestroCard from '../../../../assets/images/payment-icon-set/icons/maestro-curved-32px.png';


export function getCardBrandImage(brand) {
  const brandLower = brand?.toLowerCase();
  switch (brandLower) {
    case 'visa':
      return cardVisa;
    case 'mastercard':
      return cardMasterCard;
    case 'american_express':
    case 'amex':
      return cardAmericanExpress;
    case 'visa_electron':
      return cardVisaElectron;
    case 'maestro':
      return cardMaestroCard;
    default:
      return cardVisa;
  }
}